<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row mb-4">
      <div class="col-md-8">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">
              {{ isEdicao ? 'Editar Ordem de Produção' : 'Nova Ordem de Produção' }}
            </h1>
            <p class="welcome-message">
              <button mat-icon-button (click)="cancelar()" aria-label="Voltar">
                <mat-icon>arrow_back</mat-icon>
              </button>
              Preencha os dados da ordem de produção
            </p>
          </div>
        </div>
      </div>
      @if (numeroOrdemProducao) {
      <div class="col-md-4 text-md-end numero-op-header">
        Número da OP <strong>{{ numeroOrdemProducao }}</strong>
      </div>
      }
    </div>

    <form [formGroup]="model">
      <!-- ── Produto e quantidade ─────────────────────────────────────────── -->
      <div class="section-container">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">conveyor_belt</mat-icon>
          <span>Produto</span>
        </div>

        <div class="row">
          <div class="col-12 col-md-8 col-lg-9">
            <app-select-pesquisavel label="Produto a ser produzido" [control]="$any(model.get('idProduto'))"
              [idField]="'idProduto'" [nameField]="'descricao'" [apiUrl]="urlProdutoLookup"
              [extraParams]="filtroProdutoFabricado" (selectionChange)="onProdutoAlterado($event)"
              [subtitleFields]="['codigoSku', 'saldoFisico']"
              [subtitleLabels]="{ codigoSku: 'SKU', saldoFisico: 'Estoque atual' }"
              [badgeField]="'isFabricado'" badgeLabel="Fabricado"
              hint="Apenas produtos do tipo Fabricado">
            </app-select-pesquisavel>
            @if (produtoInvalido) {
            <div class="mensagem-erro">Selecione o produto a ser produzido.</div>
            }
            @if (model.get('idProduto')?.value) {
            <span class="status-badge badge-verde badge-fabricado">Fabricado</span>
            }
          </div>

          <div class="col-12 col-md-4 col-lg-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Quantidade{{ unidadeProduto ? ' (' + unidadeProduto + ')' : '' }}</mat-label>
              <input matInput formControlName="quantidade" [currencyMask]="quantidadeMask" />
              @if (model.get('quantidade')?.invalid && model.get('quantidade')?.touched) {
              <mat-error>Informe uma quantidade maior que zero</mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data início</mat-label>
              <input matInput [matDatepicker]="pickerData" formControlName="dataInicio" placeholder="DD/MM/AAAA"
                (input)="onDateInput($event, 'dataInicio')" />
              <mat-datepicker-toggle matIconSuffix [for]="pickerData"></mat-datepicker-toggle>
              <mat-datepicker #pickerData></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-6 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data prevista de término</mat-label>
              <input matInput [matDatepicker]="pickerPrevista" formControlName="dataPrevistaTermino"
                placeholder="DD/MM/AAAA" (input)="onDateInput($event, 'dataPrevistaTermino')" />
              <mat-datepicker-toggle matIconSuffix [for]="pickerPrevista"></mat-datepicker-toggle>
              <mat-datepicker #pickerPrevista></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- ── Composição ───────────────────────────────────────────────────── -->
      <div class="section-container">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
          <span>Composição</span>
          @if (temComposicao) {
          <span class="hint-automatico">
            <mat-icon class="material-symbols-outlined">sync</mat-icon>
            Preenchida automaticamente pela estrutura do produto
          </span>
          }
        </div>

        @if (_isLoading) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else if (temComposicao) {
        <div class="table-responsive desktop-view">
          <table mat-table [dataSource]="composicao">
            <ng-container matColumnDef="nome">
              <th mat-header-cell *matHeaderCellDef>Matéria-prima</th>
              <td mat-cell *matCellDef="let item">{{ item.nomeProduto }}</td>
            </ng-container>

            <ng-container matColumnDef="sku">
              <th mat-header-cell *matHeaderCellDef>Código (SKU)</th>
              <td mat-cell *matCellDef="let item" class="text-muted">{{ item.codigoSku }}</td>
            </ng-container>

            <ng-container matColumnDef="quantidadeUnitaria">
              <th mat-header-cell *matHeaderCellDef class="text-end">Qtd. unitária</th>
              <td mat-cell *matCellDef="let item" class="text-end coluna-numerica">
                {{ item.quantidadeUnitaria | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0) }} {{ item.unidade }}
              </td>
            </ng-container>

            <ng-container matColumnDef="quantidadeTotal">
              <th mat-header-cell *matHeaderCellDef class="text-end">Qtd. total</th>
              <td mat-cell *matCellDef="let item" class="text-end coluna-numerica fw-semibold">
                {{ item.quantidadeTotal | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0) }} {{ item.unidade }}
              </td>
            </ng-container>

            <ng-container matColumnDef="saldo">
              <th mat-header-cell *matHeaderCellDef class="text-end">Estoque atual</th>
              <td mat-cell *matCellDef="let item" class="text-end coluna-numerica"
                [class.saldo-insuficiente]="saldoInsuficiente(item)">
                {{ item.saldoAtual | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0) }} {{ item.unidade }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="colunasComposicao"></tr>
            <tr mat-row *matRowDef="let row; columns: colunasComposicao"></tr>
          </table>
        </div>

        <div class="mobile-view">
          @for (item of composicao; track item.idProduto) {
          <div class="item-card">
            <div class="item-card__header">
              <div class="item-card__produto">
                <strong>{{ item.nomeProduto }}</strong>
                @if (item.codigoSku) { <span class="item-card__sku">SKU: {{ item.codigoSku }}</span> }
              </div>
            </div>
            <div class="item-card__body">
              <div class="item-card__grid">
                <div>
                  <span class="item-card__label">Qtd. unitária</span>
                  <span>{{ item.quantidadeUnitaria | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0) }} {{ item.unidade
                    }}</span>
                </div>
                <div>
                  <span class="item-card__label">Qtd. total</span>
                  <span class="fw-semibold">{{ item.quantidadeTotal | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0)
                    }} {{ item.unidade }}</span>
                </div>
                @if (saldoApurado) {
                <div>
                  <span class="item-card__label">Estoque atual</span>
                  <span [class.saldo-insuficiente]="saldoInsuficiente(item)">
                    {{ item.saldoAtual | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0) }} {{ item.unidade }}
                  </span>
                </div>
                }
              </div>
            </div>
          </div>
          }
        </div>
        } @else {
        <p class="texto-vazio">
          Selecione um produto fabricado e informe a quantidade para preencher a composição.
        </p>
        }
      </div>

      <!-- ── Etapas ───────────────────────────────────────────────────────── -->
      <div class="section-container">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">checklist</mat-icon>
          <span>Etapas da Produção</span>
        </div>

        @if (etapas.length > 0) {
        <!-- Lista simples, não tabela: numa OP recém-criada não existe data/status real de
             etapa — isso só nasce na execução (tela de Detalhe, fase posterior). -->
        <ol class="lista-etapas">
          @for (etapa of etapas; track etapa.ordem) {
          <li class="item-etapa">
            <span class="numero-etapa">{{ etapa.ordem }}</span>
            <span>{{ etapa.descricao }}</span>
          </li>
          }
        </ol>
        } @else {
        <p class="texto-vazio">As etapas são carregadas da estrutura do produto selecionado.</p>
        }
      </div>

      <!-- ── Observações e tags ───────────────────────────────────────────── -->
      <div class="section-container">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">notes</mat-icon>
          <span>Observações e tags</span>
        </div>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Observações</mat-label>
          <textarea matInput formControlName="observacoes" rows="4"></textarea>
        </mat-form-field>

        <app-select-pesquisavel label="Tags" [control]="$any(model.get('listIdTagProducao'))"
          [idField]="'idTagProducao'" [nameField]="'descricao'" [offlineList]="listaTags" [showBadges]="true"
          [multiple]="true" [isOptional]="true" hint="Selecione tags" [corField]="'cor'">
        </app-select-pesquisavel>
      </div>

    </form>
  </div>
</div>

<app-footer-action [isLoadingSalvar]="_isSalvando" (cancelar)="cancelar()" (salvar)="salvar()"></app-footer-action>